<script setup lang="ts">
import { useModalManager } from "@/composables/useModalManager";
import { useAuthenticationStore } from "@/stores/useAuthenticationStore";
import { ModalEnum } from "@/types/enums";
import { launchConfetti } from "@/utils/confetti";
import { onMounted, onUnmounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const { setActiveModal, activeModal, executePendingActions } = useModalManager();
const router = useRouter();
const route = useRoute();
const authStore = useAuthenticationStore();
const confettiTimes = ref(2);

const showConfetti = () => {
  confettiTimes.value = 2;
  const launch = () => {
    if (confettiTimes.value > 0) {
      launchConfetti();
      confettiTimes.value -= 1;
      setTimeout(launch, 500);
    }
  };
  launch();
};

const handleLoadAction = async (query) => {
  if (query.payment) {
    // Handle payments after load actions
    if (route.query.payment !== "success") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "subscribeFailed"
      });
      setActiveModal(ModalEnum.PaymentFailedModal);
      return;
    }

    if (route.query.user && authStore.user.has_access) {
      localStorage.setItem("4c_direct_payment", "true");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "subscribeFE",
        ecommerce: {
          value: 19.00,
          currency: "USD"
        }
      });
      setActiveModal(ModalEnum.PaymentSuccessModal);
    } else if (route.query.directp == "true") {
      localStorage.setItem("4c_direct_payment", "true");
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "subscribeFE",
        ecommerce: {
          value: 19.99,
          currency: "USD"
        }
      });
      setActiveModal(ModalEnum.DirectPurchaseModal);
    }
    await afterAction();
    showConfetti();
  } else if (query.auth_callback) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "subscribeFailed"
    });
    await afterAction();
  } else if (query.reset_password) {
    // Handle reset password after actions
    setActiveModal(ModalEnum.AuthModal);
  }
};

const afterAction = async () => {
  executePendingActions();
  router.replace({ query: {} });
};

let campaignInterval: any;

onMounted(async () => {
  await handleLoadAction(route.query);
  campaignInterval = setInterval(() => {
    if (!activeModal.value) {
      setActiveModal(ModalEnum.CampaignModal);
    }
  }, 5000);
});

onUnmounted(() => {
  if (campaignInterval) clearInterval(campaignInterval);
});
</script>

<template>
  <slot></slot>
</template>
